module.exports = __webpack_public_path__ + "static/media/orotti_(1).369f84a8.jpg";